import { render, staticRenderFns } from "./AlarmDesktopLink.vue?vue&type=template&id=02a48cc0&scoped=true&"
import script from "./AlarmDesktopLink.vue?vue&type=script&lang=js&"
export * from "./AlarmDesktopLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a48cc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4088215791/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02a48cc0')) {
      api.createRecord('02a48cc0', component.options)
    } else {
      api.reload('02a48cc0', component.options)
    }
    module.hot.accept("./AlarmDesktopLink.vue?vue&type=template&id=02a48cc0&scoped=true&", function () {
      api.rerender('02a48cc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Devices/Shared/AlarmDesktopLink.vue"
export default component.exports